exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createBTSuggestion{padding:18px 18px}@media screen and (min-width: 800px){#tableSuggestionCategories{width:70%}}@media screen and (max-width: 600px){#dialogFormSuggestion{width:100%}}\n", ""]);

// exports
